import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "animate.css";
import { getAllStaff } from "../../CrudOperations/GetOperation";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

// Reusable Card Component
const StatCard = ({ title, value, colors, onClick }) => (
  <div
    onClick={onClick}
    className={`cursor-pointer ${colors} p-5 rounded-xl shadow-md transition-transform transform hover:scale-105 hover:shadow-lg text-white`}
  >
    <h2 className="text-lg md:text-xl font-semibold mb-2">{title}</h2>
    <p className="text-2xl md:text-3xl font-bold">{value}</p>
  </div>
);

const Dashboard = () => {
  const navigate = useNavigate();
  const Merchanttoken =  useSelector((state) => state.auth.token);


  const [totalDeputies, setTotalDeputies] = React.useState([]);
  const [assignedDeputies, setAssignedDeputies] = React.useState(0);
  const [activeDeputies, setActiveDeputies] = React.useState(0);
  const [eventList, setEventList] = React.useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [
          totalDeputiesRes,
          assignedDeputiesRes,
          activeDeputiesRes,
          eventListRes,
        ] = await Promise.all([
         getAllStaff(),
             getAllStaff(),
        getAllStaff(),
             getAllStaff(),
        ]);


        if (totalDeputiesRes.data.Message === "Success") {
          
        setTotalDeputies(totalDeputiesRes.data.Data);
      }


      } catch (error) {
        toast.error(error)
      }
    };

    fetchData();
  }, []);

  return (
    <div className="p-6 bg-gray-100 min-h-screen animate__animated animate__fadeIn">
      <h1 className="text-2xl md:text-2xl border-red-600     font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 mb-8 animate__animated animate__fadeInDown tracking-tight flex items-center gap-3">
        🚀 Admin Desk
      </h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        <StatCard
          title="Total Deputies"
          value={totalDeputies.length}
          colors="bg-gradient-to-r from-purple-600 to-indigo-600"
           onClick={() => navigate(`/${Merchanttoken}/manageStaff`)}
        />
        <StatCard
          title="Deputies Assigned"
          value={assignedDeputies}
          colors="bg-gradient-to-r from-pink-500 to-purple-500"
                   onClick={() => navigate(`/${Merchanttoken}/manageStaff`)}
        />
        <StatCard
          title="Active Deputies Today"
          value={activeDeputies}
          colors="bg-gradient-to-r from-green-500 to-teal-500"
         onClick={() => navigate(`/${Merchanttoken}/manageStaff`)}
        />
        <StatCard
          title="Upcoming Events"
          value={eventList}
          colors="bg-gradient-to-r from-yellow-500 to-orange-500"
         onClick={() => navigate(`/${Merchanttoken}/manageStaff`)}
        />
      </div>
    </div>
  );
};

export default Dashboard;
